var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceFltInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8 3.01001H2.2C1.538 3.01001 1 3.54801 1 4.21001V15.8C1 16.462 1.538 17 2.2 17H17.8C18.462 17 19 16.462 19 15.8V4.21001C19 3.54801 18.462 3.01001 17.8 3.01001ZM17.5 4.50001V15.5H2.5V4.50001H17.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.056 6H1.792V7H18.056V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 9.5H13.9C13.68 9.5 13.5 9.32 13.5 9.1V8.4C13.5 8.18 13.68 8 13.9 8H14.6C14.82 8 15 8.18 15 8.4V9.1C15 9.32 14.82 9.5 14.6 9.5Z",
    fill: "#FFC629"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 9.5H10.9C10.68 9.5 10.5 9.32 10.5 9.1V8.4C10.5 8.18 10.68 8 10.9 8H11.6C11.82 8 12 8.18 12 8.4V9.1C12 9.32 11.82 9.5 11.6 9.5Z",
    fill: "#FFC629"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 9.5H7.9C7.68 9.5 7.5 9.32 7.5 9.1V8.4C7.5 8.18 7.68 8 7.9 8H8.6C8.82 8 9 8.18 9 8.4V9.1C9 9.32 8.82 9.5 8.6 9.5Z",
    fill: "#FFC629"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 11.986H13.9C13.68 11.986 13.5 11.806 13.5 11.586V10.886C13.5 10.666 13.68 10.486 13.9 10.486H14.6C14.82 10.486 15 10.666 15 10.886V11.586C15 11.808 14.82 11.986 14.6 11.986Z",
    fill: "#FFC629"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 11.95H10.936C10.716 11.95 10.536 11.77 10.536 11.55V10.886C10.536 10.666 10.716 10.486 10.936 10.486H11.6C11.82 10.486 12 10.666 12 10.886V11.55C12 11.77 11.82 11.95 11.6 11.95Z",
    fill: "#FFC629"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 11.986H7.9C7.68 11.986 7.5 11.806 7.5 11.586V10.886C7.5 10.666 7.68 10.486 7.9 10.486H8.6C8.82 10.486 9 10.666 9 10.886V11.586C9 11.808 8.82 11.986 8.6 11.986Z",
    fill: "#FFC629"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 11.986H4.9C4.68 11.986 4.5 11.806 4.5 11.586V10.886C4.5 10.666 4.68 10.486 4.9 10.486H5.6C5.82 10.486 6 10.666 6 10.886V11.586C6 11.808 5.82 11.986 5.6 11.986Z",
    fill: "#FFC629"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.652 14.5H4.952C4.732 14.5 4.552 14.32 4.552 14.1V13.4C4.552 13.18 4.732 13 4.952 13H5.652C5.872 13 6.052 13.18 6.052 13.4V14.1C6.052 14.32 5.872 14.5 5.652 14.5Z",
    fill: "#FFC629"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 14.5H10.9C10.68 14.5 10.5 14.32 10.5 14.1V13.4C10.5 13.18 10.68 13 10.9 13H11.6C11.82 13 12 13.18 12 13.4V14.1C12 14.32 11.82 14.5 11.6 14.5Z",
    fill: "#FFC629"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 14.5H7.9C7.68 14.5 7.5 14.32 7.5 14.1V13.4C7.5 13.18 7.68 13 7.9 13H8.6C8.82 13 9 13.18 9 13.4V14.1C9 14.32 8.82 14.5 8.6 14.5Z",
    fill: "#FFC629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceFltInfo);
export default __webpack_public_path__ + "static/media/vip-lounge-service-flt_info.198ae5007b81d7c0071a4a6f1e3787d2.svg";
export { ForwardRef as ReactComponent };